(function () {
  if (window.LEGUInfiniteCollectionLoaded) return;
  window.LEGUInfiniteCollectionLoaded = true;

  function initInfiniteCollection() {
    var pagination = document.querySelector('.legu-infinite-pagination');
    if (!pagination) return;

    var nextLink = pagination.querySelector('.legu-infinite-next');
    var button = pagination.querySelector('.legu-infinite-button');
    var loader = pagination.querySelector('.legu-infinite-loader');

    if (!nextLink) return;

    var isLoading = false;

    function getProductContainer() {
      return document.querySelector('.legu-promo-grid-list') || document.querySelector('.collection-listing .product-grid');
    }

    function getItemsFromContainer(container) {
      if (!container) return [];

      if (container.classList.contains('legu-promo-grid-list')) {
        return Array.prototype.slice.call(container.children);
      }

      return Array.prototype.slice.call(container.children);
    }

    function setLoading(state) {
      isLoading = state;

      if (button) {
        button.disabled = state;
        button.style.display = state ? 'none' : '';
      }

      if (loader) {
        loader.style.display = state ? 'block' : 'none';
      }
    }

    function loadNextPage() {
      if (isLoading || !nextLink || !nextLink.href) return;

      setLoading(true);

      fetch(nextLink.href)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var currentContainer = getProductContainer();
          var nextContainer = doc.querySelector('.legu-promo-grid-list') || doc.querySelector('.collection-listing .product-grid');

          if (!currentContainer || !nextContainer) {
            setLoading(false);
            return;
          }

          var nextItems = getItemsFromContainer(nextContainer);

          nextItems.forEach(function (item) {
            currentContainer.appendChild(item);
          });

          var newNextLink = doc.querySelector('.legu-infinite-next');

          if (newNextLink && newNextLink.href) {
            nextLink.href = newNextLink.href;
            setLoading(false);
          } else {
            pagination.remove();
            nextLink = null;
          }
        })
        .catch(function () {
          setLoading(false);
        });
    }

    if (button) {
      button.addEventListener('click', function () {
        loadNextPage();
      });
    }

    var observerTarget = document.createElement('div');
    observerTarget.className = 'legu-infinite-observer';
    pagination.parentNode.insertBefore(observerTarget, pagination);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    }, {
      rootMargin: '600px 0px'
    });

    observer.observe(observerTarget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initInfiniteCollection);
  } else {
    initInfiniteCollection();
  }

  document.addEventListener('shopify:section:load', initInfiniteCollection);
})();